import type { MediaRoom } from './utils/liveMedia.utils';

import { AGORA } from '@/constants';
import store from '@/store';

let usingCloudProxy = false;

export function setUsingCloudProxy(value: boolean) {
  usingCloudProxy = value;
}

// Properties are sent to Segment, so organization identifiers are intentionally left out; eventId identifies the org internally.
export const getTrackingValues = (mediaRoom: MediaRoom) => {
  if (!mediaRoom) {
    return {};
  }
  const isScreen = mediaRoom.channelName?.includes(AGORA.UID_SUFFIX.SCREEN_STREAM);
  return {
    page: store.state.route.name,
    eventId: store.state.route.params?.eventID,
    channelName: mediaRoom.channelName,
    isScreen: isScreen,
    userRole: mediaRoom.userRole,
    isUsingCloudProxy: usingCloudProxy,
    proxyMode:
      store.state.mediaroom.channelPeerConnectionStates?.[mediaRoom.channelName]?.progressiveCloudProxyMode ||
      store.state.mediaroom.channelPeerConnectionStates?.[mediaRoom.channelName]?.turnServerUrl ||
      'no',
    lr: window.logrocketSessionUrl,
    useCloudProxyFlow: store.state.event.useCloudProxyFlow,
    turnServerFallbackStatus:
      store.state.mediaroom?.channelPeerConnectionStates[mediaRoom.channelName]?.turnServerFallbackStatus,
    turnServerUrl: store.state.mediaroom.channelPeerConnectionStates[mediaRoom.channelName]?.turnServerUrl,
    isUserHost: store.getters['event/isBroadcastSpeakerOrOrganizer']
  };
};
